import { SortDirection } from '@tanstack/react-table';
import { FC } from 'react';
import styled, { css } from 'styled-components';
import { colorBlue, colorGray } from '@atlas-frontend/design-tokens';
import * as Icon from 'react-feather';

type SortIndicatorProps = {
  sort: SortDirection | false;
};

export const SortIndicator: FC<SortIndicatorProps> = ({ sort }) => {
  return (
    <SortIndicatorWrapper>
      <Ascending $active={sort === 'asc'} size={14} />
      <Descending $active={sort === 'desc'} size={14} />
    </SortIndicatorWrapper>
  );
};

type SortingIndicatorIconProps = {
  $active: boolean;
};

const SortIndicatorCommon = css<SortingIndicatorIconProps>`
  font-size: 12px;
  transition: color 0.3s;

  ${(props) =>
    props.$active &&
    `
    color: ${colorBlue[5]} !important;
    `}
`;

const SortIndicatorWrapper = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colorGray[6]};
`;

const Ascending = styled(Icon.ChevronUp)<SortingIndicatorIconProps>`
  margin-bottom: -3px;
  stroke-width: 3px;
  ${SortIndicatorCommon}
`;

const Descending = styled(Icon.ChevronDown)<SortingIndicatorIconProps>`
  margin-top: -3px;
  stroke-width: 3px;
  ${SortIndicatorCommon}
`;
